import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function QuincyProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Quincy"
      headingExtra="IL"
      introText="Quincy travelers — Blessing Health System medical professionals, JWCC international students, Tri-State (IL/MO/IA) manufacturing teams, Mississippi River barge industry workers, and Adams County families — have several options for getting a passport fast. Here is how they compare, and why most Quincy residents choose a registered U.S. Department of State courier for reliable processing without the 300-mile drive to Chicago."
      options={options}
      emergencyDescription="Strictly for documented life-or-death emergencies. You must obtain an appointment in advance — no walk-ins permitted. Nearest agency: Chicago (~300 miles via I-72/I-55, 4.5+ hours). While Illinois has one passport agency in Chicago, it serves the entire state — Quincy residents face a full day of travel just to reach it. Mississippi River flooding can close I-72 and US-24 access routes during spring months, cutting off Quincy from eastbound travel entirely."
      disclaimerText="*Processing speed depends on eligibility and documentation. Regional Agency Processing requires life-or-death emergency documentation. Nearest passport agency: Chicago Passport Agency (~300 miles via I-72/I-55)."
    />
  );
}